import { Chip, SxProps, Theme } from '@mui/material';

const customStyles: Record<string, SxProps<Theme>> = {
  chip: {
    height: '24px',
    borderRadius: '4px',
    backgroundColor: '#FAFBFF',
    border: '1px solid #DDE0E5',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
};

interface SelectorChipProps {
  name: string;
  onDelete?: () => void;
  disabled?: boolean;
}

export function SelectorChip({ name, onDelete, disabled }: SelectorChipProps) {
  return (
    <Chip
      sx={customStyles.chip}
      label={name}
      size='small'
      onDelete={onDelete}
      disabled={disabled}
    />
  );
}
